import { SortOrder } from '@dealroadshow/uikit/core/components/Table/DataTable/interfaces/SortOrder';

export const initialArticleTilesFiltersState = {
  filter: {},
  isExtended: false,
  search: '',
  sortBy: 'publishedAt',
  sortOrder: 'desc' as SortOrder,
  page: 1,
  perPage: 10,
};

export const initialArticleTilesData = {
  collection: [],
  totalCount: 0,
  payload: initialArticleTilesFiltersState,
};

export const excludedArticleTypes = ['ABS', 'CLO', 'CMBS', 'RMBS'];
